import { useDisableSwipingBackToThePreviousPage } from '@/src/common/hooks/disableSwipingBackToThePreviousPage'
import * as CardActivity from '@/src/experiences/card-activity'
import * as CardPlatform from '@/src/experiences/card-platform'
import { useRefreshPoints } from '@/src/common/hooks/usePoints'
import type { PropsWithChildren } from 'react'
import { CardActivityFeedBottomSheetHeightStore } from '@/src/experiences/card-activity/components/feed/_highnote'

export function CardAccountSummary({
  children,
  refetchCardAccountSummary,
  cardActivityFeedBottomSheetHeightStore,
}: PropsWithChildren<{
  refetchCardAccountSummary: () => void
  cardActivityFeedBottomSheetHeightStore: CardActivityFeedBottomSheetHeightStore
}>) {
  // once the card management page should be shown (because the card was issued from the application),
  // we should no longer allow the user to swipe to the previous page from the card application route,
  // which would erroneously cause the user to end up in application-specific states even though the
  // application was already approved and the card was issued
  useDisableSwipingBackToThePreviousPage()

  const Feed = CardPlatform.Components.Gate({
    Highnote: CardActivity.Components.Highnote.Feed,
    Platform: CardActivity.Components.Feed,
  })
  const refreshPoints = useRefreshPoints()

  return (
    <Feed
      cardActivityFeedBottomSheetHeightStore={cardActivityFeedBottomSheetHeightStore}
      onRefresh={() => {
        void refreshPoints()
        refetchCardAccountSummary()
      }}
    >
      {children}
    </Feed>
  )
}
